function checkHasBillingCycleAnchorConfig(product) {
  if (
    product.billingCycleAnchorConfig?.enabled &&
    (product.interval === 'year' || product.interval === 'month')
  ) {
    return true;
  }

  return false;
}

export { checkHasBillingCycleAnchorConfig };
